<template>
  <div class="card">
    <div
      v-if="title"
      class="card-header"
      style="cursor: pointer;"
      @click="toggleCollapse"
    >
      <p class="card-header-title" style="border-bottom: 1px solid lightgray;">
        <b-icon
          v-if="icon"
          :icon="icon"
          custom-size="default"
        />
        {{ title }}
      </p>
      <a
        href="#"
        class="card-header-icon"
        aria-label="toggle content"
        @click.prevent="toggleCollapse"
        v-if="isCollapsedOption"
      >
        <b-icon
          :icon="isCollapsed ? 'chevron-down' : 'chevron-up'"
          custom-size="default"
        />
      </a>
    </div>
    <div
      v-if="!isCollapsed"
      class="card-content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'CardComponent',
  props: {
    title: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    isCollapsedOption: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isCollapsed = ref(false);

    function toggleCollapse() {
      // Verifique se isCollapsedOption é false e, nesse caso, não execute a função
      if (!props.isCollapsedOption) {
        return;
      }
      // Alterne o estado de colapso
      isCollapsed.value = !isCollapsed.value;
    }

    return { isCollapsed, toggleCollapse };
  },
});
</script>
